import { SmallText } from './Text';
import styled from 'styled-components';

const Anchor = styled.a`
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: -16px; // positions the separator exactly halfway between items
    height: 40%; // adjust as needed
    width: 1px;
    background-color: #d3d3d3;
    top: 30%; // centers vertically
  }

  &:hover {
    opacity: 0.6;
  }
`;

export interface IconProps {
  text: string;
  link: string;
}

export default function Icon({ text, link }: IconProps): React.ReactElement {
  return (
    <Anchor target="_blank" href={link} rel="noreferrer">
      <SmallText>{text}</SmallText>
    </Anchor>
  );
}
